export { IxIconButton } from './IxIconButton.js';
